// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import SearchController from "./search_controller";
application.register("search", SearchController);

import CategoriesController from "./categories_controller";
application.register("categories", CategoriesController);

import ProvidersController from "./providers_controller";
application.register("providers", ProvidersController);

import SettingsController from "./settings_controller";
application.register("settings", SettingsController);

import ContentDetailController from "./content_detail_controller";
application.register("content-detail", ContentDetailController);

import FlowController from "./flow_controller";
application.register("flow", FlowController);

import FollowsController from "./follows_controller";
application.register("follows", FollowsController);

import LikesController from "./likes_controller";
application.register("likes", LikesController);

import EventCommentsController from "./event_comments_controller";
application.register("event-comments", EventCommentsController);

import FandomFormController from "./fandom_form_controller";
application.register("fandom-form", FandomFormController);

import FandomCommentsController from "./fandom_comments_controller";
application.register("fandom-comments", FandomCommentsController);

import FandomsController from "./fandoms_controller";
application.register("fandoms", FandomsController);

import UserProfileController from "./user_profile_controller";
application.register("user-profile", UserProfileController);

import WebEventsController from "./web_events_controller";
application.register("web-events", WebEventsController);

import UserFollowController from "./user_follow_controller";
application.register("user-follow", UserFollowController);

import TopContentController from "./top_content_controller";
application.register("top-content", TopContentController);

import NotificationsController from "./notifications_controller";
application.register("notifications", NotificationsController);

import BingeController from "./binge_controller";
application.register("binge", BingeController);

import NewContentController from "./new_content_controller";
application.register("new-content", NewContentController);

import ContentTagsController from "./content_tags_controller";
application.register("content-tags", ContentTagsController);

import SharedWatchController from "./shared_watch_controller";
application.register("shared-watch", SharedWatchController);

import CheckoutController from "./checkout_controller";
application.register("checkout", CheckoutController);

import ForgotPasswordController from "./forgot_password_controller";
application.register("forgot-password", ForgotPasswordController);

import SignupController from "./signup_controller";
application.register("signup", SignupController);
